import React from "react";
import { View, StyleSheet, Image } from "react-native";
import NtCaseStudyTitle from "./NtCaseStudyTitle";
import NtCaseStudyDescription from "./NtCaseStudyDescription";

function NtCaseStudySectionContainer({
  containerStyle,
  children,
  title,
  subtitle,
  image,
  imageStyle,
}) {
  return (
    <View style={[styles.container, containerStyle]}>
      <View style={{ maxWidth: "80%" }}>
        {image && <Image style={[styles.image, imageStyle]} source={image} />}

        <NtCaseStudyTitle style={{ marginTop: 40 }}>{title}</NtCaseStudyTitle>
        <NtCaseStudyDescription style={{ marginTop: 25 }}>
          {subtitle}
        </NtCaseStudyDescription>

        <View style={{ marginTop: 30, width: "100%" }}>{children}</View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    alignItems: "center",
    paddingTop: 100,
    paddingBottom: 60,
  },
  image: {
    width: 160,
    height: 60,
    resizeMode: "contain",
  },
});

export default NtCaseStudySectionContainer;
